module.exports = __webpack_public_path__ + "static/media/Assets-02-HRA-hero.90b91373.png";